import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as account from '../../app/store/account'
import * as app from '../../app/store/app'
export const rootReducer = combineReducers({
  auth: auth.reducer,
  account: account.reducer,
  app: app.reducer,
})
export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga(), app.saga()])
}
